export const BASE_URL = 'http://api-qlvbcc.backan.edu.vn';
